import type { NextPage } from "next";
import dynamic from "next/dynamic";

// AuthKitがサーバサイドでは使用できないため, dynamic importする
const UserAuthContext = dynamic(
  () => import("../components/contexts/user-auth-context"),
  { ssr: false }
);
const HomeComponent = dynamic(
  () => import("../components/pages/users/home/home"),
  { ssr: false }
);

const Home: NextPage = () => {
  return <UserAuthContext Component={HomeComponent} />;
};

export default Home;
